const full = [
  '/images/photos/2024/06/frame_1.webp',
  '/images/photos/2024/06/frame_10.webp',
  '/images/photos/2024/06/frame_11.webp',
  '/images/photos/2024/06/frame_12.webp',
  '/images/photos/2024/06/frame_13.webp',
  '/images/photos/2024/06/frame_14.webp',
  '/images/photos/2024/06/frame_15.webp',
  '/images/photos/2024/06/frame_16.webp',
  '/images/photos/2024/06/frame_17.webp',
  '/images/photos/2024/06/frame_18.webp',
  '/images/photos/2024/06/frame_19.webp',
  '/images/photos/2024/06/frame_2.webp',
  '/images/photos/2024/06/frame_20.webp',
  '/images/photos/2024/06/frame_21.webp',
  '/images/photos/2024/06/frame_22.webp',
  '/images/photos/2024/06/frame_23.webp',
  '/images/photos/2024/06/frame_24.webp',
  '/images/photos/2024/06/frame_25.webp',
  '/images/photos/2024/06/frame_26.webp',
  '/images/photos/2024/06/frame_27.webp',
  '/images/photos/2024/06/frame_28.webp',
  '/images/photos/2024/06/frame_29.webp',
  '/images/photos/2024/06/frame_3.webp',
  '/images/photos/2024/06/frame_30.webp',
  '/images/photos/2024/06/frame_31.webp',
  '/images/photos/2024/06/frame_32.webp',
  '/images/photos/2024/06/frame_33.webp',
  '/images/photos/2024/06/frame_34.webp',
  '/images/photos/2024/06/frame_35.webp',
  '/images/photos/2024/06/frame_36.webp',
  '/images/photos/2024/06/frame_37.webp',
  '/images/photos/2024/06/frame_38.webp',
  '/images/photos/2024/06/frame_39.webp',
  '/images/photos/2024/06/frame_4.webp',
  '/images/photos/2024/06/frame_40.webp',
  '/images/photos/2024/06/frame_41.webp',
  '/images/photos/2024/06/frame_42.webp',
  '/images/photos/2024/06/frame_43.webp',
  '/images/photos/2024/06/frame_44.webp',
  '/images/photos/2024/06/frame_45.webp',
  '/images/photos/2024/06/frame_5.webp',
  '/images/photos/2024/06/frame_6.webp',
  '/images/photos/2024/06/frame_7.webp',
  '/images/photos/2024/06/frame_8.webp',
  '/images/photos/2024/06/frame_9.webp',

  '/images/photos/culture/culture-10-min.jpg',
  '/images/photos/culture/culture-4-min.jpg',
  '/images/photos/culture/culture-5-min.jpg',
  '/images/photos/culture/culture-6-min.jpg',
  '/images/photos/culture/culture-11-min.jpg',
  '/images/photos/culture/culture-13-min.jpg',
  '/images/photos/culture/culture-15-min.jpg',
  '/images/photos/culture/culture-21-min.jpg',
  '/images/photos/culture/culture-26-min.jpg',
  '/images/photos/culture/culture-27-min.jpg',
  '/images/photos/culture/culture-28-min.jpg',
  '/images/photos/culture/culture-31-min.jpg',
  '/images/photos/culture/culture-33-min.jpg',
  '/images/photos/culture/culture-34-min.jpg',
  '/images/photos/culture/culture-1-min.jpg',

  '/images/photos/culture/2022-10/Image-1-940x740.jpg',
  '/images/photos/culture/2022-10/Image-10-940x740.jpg',
  '/images/photos/culture/2022-10/Image-11-940x740.jpg',
  '/images/photos/culture/2022-10/Image-12-940x740.jpg',
  '/images/photos/culture/2022-10/Image-14-940x740.jpg',
  '/images/photos/culture/2022-10/Image-15-940x740.jpg',
  '/images/photos/culture/2022-10/Image-16-940x740.jpg',
  '/images/photos/culture/2022-10/Image-18-940x740.jpg',
  '/images/photos/culture/2022-10/Image-19-940x740.jpg',
  '/images/photos/culture/2022-10/Image-2-940x740.jpg',
  '/images/photos/culture/2022-10/Image-20-940x740.jpg',
  '/images/photos/culture/2022-10/Image-21-940x740.jpg',
  '/images/photos/culture/2022-10/Image-22-940x740.jpg',
  '/images/photos/culture/2022-10/Image-23-940x740.jpg',
  '/images/photos/culture/2022-10/Image-24-940x740.jpg',
  '/images/photos/culture/2022-10/Image-25-940x740.jpg',
  '/images/photos/culture/2022-10/Image-26-940x740.jpg',
  '/images/photos/culture/2022-10/Image-27-940x740.jpg',
  '/images/photos/culture/2022-10/Image-28-940x740.jpg',
  '/images/photos/culture/2022-10/Image-3-940x740.jpg',
  '/images/photos/culture/2022-10/Image-33-940x740.jpg',
  '/images/photos/culture/2022-10/Image-34-940x740.jpg',
  '/images/photos/culture/2022-10/Image-35-940x740.jpg',
  '/images/photos/culture/2022-10/Image-39-940x740.jpg',
  '/images/photos/culture/2022-10/Image-4-940x740.jpg',
  '/images/photos/culture/2022-10/Image-41-940x740.jpg',
  '/images/photos/culture/2022-10/Image-42-940x740.jpg',
  '/images/photos/culture/2022-10/Image-43-940x740.jpg',
  '/images/photos/culture/2022-10/Image-44-940x740.jpg',
  '/images/photos/culture/2022-10/Image-45-940x740.jpg',
  '/images/photos/culture/2022-10/Image-46-940x740.jpg',
  '/images/photos/culture/2022-10/Image-47-940x740.jpg',
  '/images/photos/culture/2022-10/Image-49-940x740.jpg',
  '/images/photos/culture/2022-10/Image-5-940x740.jpg',
  '/images/photos/culture/2022-10/Image-50-940x740.jpg',
  '/images/photos/culture/2022-10/Image-51-940x740.jpg',
  '/images/photos/culture/2022-10/Image-52-940x740.jpg',
  '/images/photos/culture/2022-10/Image-53-940x740.jpg',
  '/images/photos/culture/2022-10/Image-55-940x740.jpg',
  '/images/photos/culture/2022-10/Image-56-940x740.jpg',
  '/images/photos/culture/2022-10/Image-57-940x740.jpg',
  '/images/photos/culture/2022-10/Image-58-940x740.jpg',
  '/images/photos/culture/2022-10/Image-6-940x740.jpg',
  '/images/photos/culture/2022-10/Image-60-940x740.jpg',
  '/images/photos/culture/2022-10/Image-62-940x740.jpg',
  '/images/photos/culture/2022-10/Image-7-940x740.jpg',
  '/images/photos/culture/2022-10/Image-8-940x740.jpg',
  '/images/photos/culture/2022-10/Image-9-940x740.jpg',
];

const previews = [
  '/images/photos/2024/06/frame_1-266x133.webp',
  '/images/photos/2024/06/frame_10-266x133.webp',
  '/images/photos/2024/06/frame_11-266x133.webp',
  '/images/photos/2024/06/frame_12-266x133.webp',
  '/images/photos/2024/06/frame_13-266x133.webp',
  '/images/photos/2024/06/frame_14-266x133.webp',
  '/images/photos/2024/06/frame_15-266x133.webp',
  '/images/photos/2024/06/frame_16-266x133.webp',
  '/images/photos/2024/06/frame_17-266x133.webp',
  '/images/photos/2024/06/frame_18-266x133.webp',
  '/images/photos/2024/06/frame_19-266x133.webp',
  '/images/photos/2024/06/frame_2-266x133.webp',
  '/images/photos/2024/06/frame_20-266x133.webp',
  '/images/photos/2024/06/frame_21-266x133.webp',
  '/images/photos/2024/06/frame_22-266x133.webp',
  '/images/photos/2024/06/frame_23-266x133.webp',
  '/images/photos/2024/06/frame_24-266x133.webp',
  '/images/photos/2024/06/frame_25-266x133.webp',
  '/images/photos/2024/06/frame_26-266x133.webp',
  '/images/photos/2024/06/frame_27-266x133.webp',
  '/images/photos/2024/06/frame_28-266x133.webp',
  '/images/photos/2024/06/frame_29-266x133.webp',
  '/images/photos/2024/06/frame_3-266x133.webp',
  '/images/photos/2024/06/frame_30-266x133.webp',
  '/images/photos/2024/06/frame_31-266x133.webp',
  '/images/photos/2024/06/frame_32-266x133.webp',
  '/images/photos/2024/06/frame_33-266x133.webp',
  '/images/photos/2024/06/frame_34-266x133.webp',
  '/images/photos/2024/06/frame_35-266x133.webp',
  '/images/photos/2024/06/frame_36-266x133.webp',
  '/images/photos/2024/06/frame_37-266x133.webp',
  '/images/photos/2024/06/frame_38-266x133.webp',
  '/images/photos/2024/06/frame_39-266x133.webp',
  '/images/photos/2024/06/frame_4-266x133.webp',
  '/images/photos/2024/06/frame_40-266x133.webp',
  '/images/photos/2024/06/frame_41-266x133.webp',
  '/images/photos/2024/06/frame_42-266x133.webp',
  '/images/photos/2024/06/frame_43-266x133.webp',
  '/images/photos/2024/06/frame_44-266x133.webp',
  '/images/photos/2024/06/frame_45-266x133.webp',
  '/images/photos/2024/06/frame_5-266x133.webp',
  '/images/photos/2024/06/frame_6-266x133.webp',
  '/images/photos/2024/06/frame_7-266x133.webp',
  '/images/photos/2024/06/frame_8-266x133.webp',
  '/images/photos/2024/06/frame_9-266x133.webp',

  '/images/photos/culture/culture-10@preview.jpg',
  '/images/photos/culture/culture-4@preview.jpg',
  '/images/photos/culture/culture-5@preview.jpg',
  '/images/photos/culture/culture-6@preview.jpg',
  '/images/photos/culture/culture-11@preview.jpg',
  '/images/photos/culture/culture-13@preview.jpg',
  '/images/photos/culture/culture-15@preview.jpg',
  '/images/photos/culture/culture-21@preview.jpg',
  '/images/photos/culture/culture-26@preview.jpg',
  '/images/photos/culture/culture-27@preview.jpg',
  '/images/photos/culture/culture-28@preview.jpg',
  '/images/photos/culture/culture-31@preview.jpg',
  '/images/photos/culture/culture-33@preview.jpg',
  '/images/photos/culture/culture-34@preview.jpg',
  '/images/photos/culture/culture-1@preview.jpg',

  '/images/photos/culture/2022-10/Image-1-266x133.jpg',
  '/images/photos/culture/2022-10/Image-10-266x133.jpg',
  '/images/photos/culture/2022-10/Image-11-266x133.jpg',
  '/images/photos/culture/2022-10/Image-12-266x133.jpg',
  '/images/photos/culture/2022-10/Image-14-266x133.jpg',
  '/images/photos/culture/2022-10/Image-15-266x133.jpg',
  '/images/photos/culture/2022-10/Image-16-266x133.jpg',
  '/images/photos/culture/2022-10/Image-18-266x133.jpg',
  '/images/photos/culture/2022-10/Image-19-266x133.jpg',
  '/images/photos/culture/2022-10/Image-2-266x133.jpg',
  '/images/photos/culture/2022-10/Image-20-266x133.jpg',
  '/images/photos/culture/2022-10/Image-21-266x133.jpg',
  '/images/photos/culture/2022-10/Image-22-266x133.jpg',
  '/images/photos/culture/2022-10/Image-23-266x133.jpg',
  '/images/photos/culture/2022-10/Image-24-266x133.jpg',
  '/images/photos/culture/2022-10/Image-25-266x133.jpg',
  '/images/photos/culture/2022-10/Image-26-266x133.jpg',
  '/images/photos/culture/2022-10/Image-27-266x133.jpg',
  '/images/photos/culture/2022-10/Image-28-266x133.jpg',
  '/images/photos/culture/2022-10/Image-3-266x133.jpg',
  '/images/photos/culture/2022-10/Image-33-266x133.jpg',
  '/images/photos/culture/2022-10/Image-34-266x133.jpg',
  '/images/photos/culture/2022-10/Image-35-266x133.jpg',
  '/images/photos/culture/2022-10/Image-39-266x133.jpg',
  '/images/photos/culture/2022-10/Image-4-266x133.jpg',
  '/images/photos/culture/2022-10/Image-41-266x133.jpg',
  '/images/photos/culture/2022-10/Image-42-266x133.jpg',
  '/images/photos/culture/2022-10/Image-43-266x133.jpg',
  '/images/photos/culture/2022-10/Image-44-266x133.jpg',
  '/images/photos/culture/2022-10/Image-45-266x133.jpg',
  '/images/photos/culture/2022-10/Image-46-266x133.jpg',
  '/images/photos/culture/2022-10/Image-47-266x133.jpg',
  '/images/photos/culture/2022-10/Image-49-266x133.jpg',
  '/images/photos/culture/2022-10/Image-5-266x133.jpg',
  '/images/photos/culture/2022-10/Image-50-266x133.jpg',
  '/images/photos/culture/2022-10/Image-51-266x133.jpg',
  '/images/photos/culture/2022-10/Image-52-266x133.jpg',
  '/images/photos/culture/2022-10/Image-53-266x133.jpg',
  '/images/photos/culture/2022-10/Image-55-266x133.jpg',
  '/images/photos/culture/2022-10/Image-56-266x133.jpg',
  '/images/photos/culture/2022-10/Image-57-266x133.jpg',
  '/images/photos/culture/2022-10/Image-58-266x133.jpg',
  '/images/photos/culture/2022-10/Image-6-266x133.jpg',
  '/images/photos/culture/2022-10/Image-60-266x133.jpg',
  '/images/photos/culture/2022-10/Image-62-266x133.jpg',
  '/images/photos/culture/2022-10/Image-7-266x133.jpg',
  '/images/photos/culture/2022-10/Image-8-266x133.jpg',
  '/images/photos/culture/2022-10/Image-9-266x133.jpg',
];

export default {
  full,
  previews,
};



// WEBPACK FOOTER //
// ./src/data/culture-photos.js